const STEPS = [
  { n: "I", h: "Apply & verify", p: "Sign the digital Membership Agreement and complete identity verification. Settlement details are shared privately, and only after the desk approves your membership." },
  { n: "II", h: "One managed mandate", p: "All allocations are deployed together as a single discretionary XAU/USD mandate, executed A-book with regulated broker VT Markets, Monday to Friday." },
  { n: "III", h: "Distributions from realised profit", p: "Only realised net trading profit is distributed, at your tier's profit share. No profit, no distribution, and losses reduce your balance. Redeem in USDT on your tier's schedule." },
];

const TRUST = ["A-book execution", "XAU/USD only", "Consolidated Treasury", "Identity-verified members only", "Profit-share only, no fixed yield", "Digital Membership Agreement", "DFI Holdings", "Abu Dhabi"];

const PHASES = [
  { p: "Phase I · Now", h: "Private circle", d: "Invitation-only. Member allocations are held in the GTA X Consolidated Treasury, a single settlement account whose address is shared privately with approved members so they can verify balances on-chain, supported by periodic member statements." },
  { p: "Phase II · Next", h: "Your own account", d: "Members migrate to individually designated, non-custodial managed accounts in their own name, with the desk trading under a limited power of attorney." },
];

export const GtaxRoadmap = () => (
  <section className="py-28 gx-line" data-testid="gtax-roadmap">
    <div className="gx-wrap">
      <p className="gx-eyebrow">Custody &amp; roadmap</p>
      <h2 className="gx-serif text-4xl md:text-5xl mt-6 max-w-2xl">Verifiable today. Individually segregated tomorrow.</h2>
      <div className="mt-16 grid md:grid-cols-2 gap-6">
        {PHASES.map((x, i) => (
          <div key={x.p} className="gx-card p-10" data-testid={`gtax-phase-${i + 1}`}>
            <div className="gx-eyebrow">{x.p}</div>
            <h3 className="gx-caps text-2xl mt-5">{x.h}</h3>
            <p className="mt-4 text-[color:var(--mute)] leading-relaxed">{x.d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const GtaxHow = () => (
  <section className="gx-ivory pt-32" data-testid="gtax-how">
    <div className="gx-wrap grid lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-7">
        <p className="gx-eyebrow">The method</p>
        <h2 className="gx-serif text-4xl md:text-5xl mt-6 max-w-xl">One mandate. Rigorous discipline. Profit shared only when realised.</h2>
        <div className="mt-16 space-y-12">
          {STEPS.map((s) => (
            <div key={s.n} className="grid grid-cols-[64px_1fr] gap-6 pb-10 border-b border-[color:var(--line)]" data-testid={`gtax-step-${s.n}`}>
              <div className="gx-serif text-4xl gx-gold">{s.n}</div>
              <div>
                <h3 className="gx-caps text-xl">{s.h}</h3>
                <p className="mt-3 text-[color:var(--mute)] leading-relaxed max-w-md">{s.p}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-5">
        <div className="gx-photo h-[520px] max-w-md mx-auto" data-testid="gtax-guardian"><img src="/gtax/vault.jpg" alt="Secure gold vault" /></div>
      </div>
    </div>
    <div className="mt-28 py-8 border-y border-[color:var(--line)]" data-testid="gtax-trust-row">
      <div className="gx-wrap grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-8 text-sm text-[color:var(--mute)]">
        {TRUST.map((t) => <span key={t} className="flex gap-3 items-center"><span className="w-1.5 h-1.5 bg-[color:var(--gold)] shrink-0" />{t}</span>)}
      </div>
    </div>
  </section>
);
